import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ProductLoanPaymentLayer from "../../../components/Admin/ProductLoanPaymentLayer";

const ProductLoanPayment = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ProductLoanPaymentLayer />
      </MasterLayout>
    </>
  );
};

export default ProductLoanPayment;
